export const REVIEW_MEMBERS_TABS = {
  CUSTOM: 'custom',
  DEFAULT: 'default',
  INELIGIBLE: 'ineligible'
} as const;

export const TAB_DESCRIPTIONS: Record<string, string> = {
  [REVIEW_MEMBERS_TABS.CUSTOM]:
    'These members have settings different from the group.',
  [REVIEW_MEMBERS_TABS.DEFAULT]:
    "These members follow the group's settings. Uncheck anyone who should stay as they are.",
  [REVIEW_MEMBERS_TABS.INELIGIBLE]: "These members can't be updated right now"
};

export const TAB_EMPTY_MESSAGES: Record<string, string> = {
  [REVIEW_MEMBERS_TABS.CUSTOM]: 'No custom members found.',
  [REVIEW_MEMBERS_TABS.DEFAULT]: 'No default members found.',
  [REVIEW_MEMBERS_TABS.INELIGIBLE]: 'No ineligible members found.'
};

export const INELIGIBLE_REASON_LABELS: Record<string, string> = {
  different_interval: 'Different interval',
  payment_order_exists: 'Payment order exists',
  inactive: 'Inactive',
  deactivated: 'Deactivated',
  course_discontinued: 'Course discontinued',
  term_before_current_term:
    "One or more terms have already passed for this member and can't be edited.",
  due_date_order_invalid:
    "Due date must fall between the previous and next term's due dates"
};

const toSentenceCase = (text: string): string =>
  text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();

export const getIneligibleReasonLabel = (reason: string): string => {
  const parts = reason.split(',').map((r) => r.trim());
  return parts
    .map(
      (part) =>
        INELIGIBLE_REASON_LABELS[part] ||
        toSentenceCase(part.replace(/_/g, ' '))
    )
    .join(', ');
};
